export function getPendo() {
  if (typeof window === 'undefined') {
    return {
      isReady() {
        return false;
      },
    } as Pendo;
  }

  if (!window.pendo) {
    console.warn('Pendo is not loaded');
    return {
      isReady() {
        return false;
      },
    } as Pendo;
  }

  return window.pendo;
}

declare global {
  interface Window {
    pendo: Pendo;
  }
}
